const ShipmentTypes = {
  SHIPMENT_TYPE_SEA: '1',
  SHIPMENT_TYPE_AIRFREIGHT: '2'
};

ShipmentTypes.install = function (Vue) {
    Vue.prototype.$getConstShipmentType = (key) => {
        return ShipmentTypes[key];
    }
}

export default ShipmentTypes;
